import { disableExplodeIcon } from '../state/ui-store';

export const disableExplodeBttn = () => disableExplodeIcon();
